import React from 'react';
import '../css/Announcement.css';

const Announcement = () => {
    const announcementTitle='STCJMIS: New Website App Launched!'
    return (
        <div className='announcement-container flex-center'>
            <div className='announcement-content flex-center'>
                {/* BUTTON - LEFT */}
                <button className='announcement-button bold cursor-pointer flex-center'>
                    <div className='image announcement-left-arrow'/>
                </button>
                {/* IMAGE */}
                <div className='image announcement-image subtle-shadow'/> {/* ASPECT RATIO 4:3*/}
                {/* BUTTON - RIGHT */}
                <button className='announcement-button bold cursor-pointer flex-center'>
                    <div className='image announcement-right-arrow'/>
                </button>
            </div>
            <div className='outfit bold secondary-white-text'>{announcementTitle}</div>
            
            {/* → */}
        </div>
    );
};

export default Announcement;